import { useEffect, useState, type CSSProperties } from "react";

// Overlays gated on layout booleans unmount and remount when the user resizes
// across a breakpoint. If the rail content was already open in another overlay
// variant, the newly-mounted overlay would replay its enter animation, which
// reads as a flicker. Skip the enter animation on the very first paint after
// mount; subsequent open/close transitions animate normally.
export const useSkipInitialEnterAnimationStyle = ():
  | CSSProperties
  | undefined => {
  const [isInitialMount, setIsInitialMount] = useState(true);
  useEffect(() => {
    const raf = requestAnimationFrame(() => setIsInitialMount(false));
    return () => cancelAnimationFrame(raf);
  }, []);
  return isInitialMount ? { animationDuration: "0s" } : undefined;
};
